import { prepHandleEvent } from "./prepHandleEvent";
import { enumKeySource, kDownArrow, kLeftArrow, kRightArrow, kUpArrow } from "../constants";

const kArrowKeys = [kLeftArrow, kUpArrow, kRightArrow, kDownArrow];

export function handleKeyDown(event) {
  var myApp = prepHandleEvent(this, false, null, null);
  if (myApp == null) return;

  var isCmdArrow = event.metaKey && kArrowKeys.includes(event.keyCode);
  if (isCmdArrow && !myApp.fWSMgr?.GetKeyboardTarget()?.InEditMode()) return;

  var handled = myApp.HandleKeyboard(event, enumKeySource.keyDown);
  if (handled) {
    event.preventDefault(); // Prevent tab key from being handled by browser
  }
}
